export const PAGE_LIMIT = 50;
